import { render, staticRenderFns } from "./PadoMJComponent.vue?vue&type=template&id=9747efdc&scoped=true"
import script from "./PadoMJComponent.vue?vue&type=script&lang=ts"
export * from "./PadoMJComponent.vue?vue&type=script&lang=ts"
import style0 from "./PadoMJComponent.vue?vue&type=style&index=0&id=9747efdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9747efdc",
  null
  
)

export default component.exports